import React from 'react';
import {extend} from '../zviz3/functions';
import imageHouse from '../images/huis.svg';
import SizedComponent from '../helpers/sizedComponent';
// import imagePointer from '../images/pointer.svg';

const pois = {
    muren: {
        title: 'Isoleren van muren',
        description: 'U krijgt subsidie voor 2 soorten muurisolatie: spouwmuurisolatie en gevelisolatie.',
        position: [67, 49]
    },
    dak: {
        title: 'Isoleren van het dak',
        description: 'Er is subsidie voor de isolatie van een bestaand dak en voor het isoleren van de bestaande vloer van de zolder of vliering. De zolder mag dan geen verwarmde leefruimte zijn.',
        position: [42, 25]
    },
    vloer: {
        title: 'Isoleren van vloer of bodem',
        description: 'Voor isolatie aangebracht onder de vloer of op de bodem van uw huis is er ook een aantrekkelijke subsidie.',
        position: [54, 68]
    },
    glas: {
        title: 'Glas',
        description: 'U kunt subsidie krijgen voor hoogrendementsglas. Dit kan HR++ of triple glas zijn. Ook geïsoleerde kozijnen en panelen in het kozijn tellen mee.',
        position: [43, 44]
    },
    aanvullend: {
        title: 'Aanvullende energiebesparende maatregelen',
        description: 'Er zijn subsidies voor onder andere voor- en achterdeuren, energiezuinige ventilatiesystemen, het waterzijdig inregelen van het verwarmingssysteem en een energiedisplay. U krijgt alleen subsidie hiervoor als u daarnaast ten minste 2 andere energiebesparende maatregelen heeft genomen.',
        position: [20, 80]
    },
    advies: {
        title: 'Advies',
        description: 'Weet u nog niet goed welke maatregelen voor uw woning het beste zijn? Schakel dan een adviseur in. U krijgt alleen subsidie voor zijn maatwerkadviesrapport als u vervolgens minimaal 2 energiebesparende maatregelen uitvoert.',
        position: [80, 80]
    }
}

const styleImg = {
    width: '50%',
    paddingTop: '50%',
    position: 'relative',
    background: 'transparent url(' + imageHouse + ') center center no-repeat',
    backgroundSize: '100%',
    cssFloat: 'left'
};

// const stylePoi = {
//     position: 'absolute',
//     width: '50px',
//     height: '50px',
//     margin: '-25px 0px 0px -25px',
//     background: 'transparent url(' + imagePointer + ') center center no-repeat',
//     backgroundSize: '100%',
//     cursor: 'pointer'
// };

const styleInfo = {
    position: 'relative',
    cssFloat: 'right',
    right: '50px',
    width: 'calc(40% - 40px)',
    backgroundColor: '#eef7fb',
    border: '2px solid #8fcae7',
    marginTop: '30px',
    padding: '0px 20px 20px',
    borderRadius: '20px',
    zIndex: 2
}

const styleButtons = {
    padding: '40px 0px 60px 0px',
    clear: 'both'
}

class Step2 extends SizedComponent{

    constructor(props){
        super(props);
        this.state = {
            poiSelected: null,
            orientation: 'landscape'
        };
        this.domNode = React.createRef();
    }

    componentSizeDidChange(){
        let orientation = 'landscape';
        let width = this.getComponentSize().width;
        if(width < 750){
            orientation = 'portrait';
        }
        if(this.state.orientation !== orientation){
            this.setState({orientation: orientation});
        }
    }

    render(){

        let info = <div>
            <h3 style={{marginTop: '28px'}}>Verken de maatregelen</h3>
            <p>In de illustratie {this.state.orientation==='landscape'? 'hiernaast': 'hierboven'} ziet u verschillende punten waar u energiebesparende maatregelen kunt nemen in uw huis. Klik op een punt voor meer informatie.</p>
        </div>;

        if(this.state.poiSelected){
            info = <div>
                <h3 style={{marginTop: '28px'}}>{pois[this.state.poiSelected].title}</h3>
                <p>{pois[this.state.poiSelected].description}</p>
                <p>Benieuwd of u in aanmerking komt voor subsidie op dit onderdeel? Doe dan de <a href="#seehiStep6">subsidiecheck</a> verderop deze pagina.</p>
            </div>;
        }

        let line = '';
        const poiElements = Object.keys(pois).map((key) => {
            const poi = pois[key];
            const style = extend({
                left: poi.position[0] + '%',
                top: poi.position[1] + '%',
            }, {});
            if(this.state.poiSelected===key){
                let top = '15%';
                let bottom = (100 - poi.position[1]) + '%';
                let left = poi.position[0] + '%';
                let right = '-20%';
                let border = '2px 0px 0px 2px';
                if(this.state.orientation === 'portrait'){
                    top = poi.position[1] + '%';
                    bottom = '-40px';
                    if(poi.position[0] < 50){
                        right = '50%';
                        border = '2px 2px 0px 0px';
                    }else{
                        right = (100-poi.position[0]) + '%';
                        left = '50%';
                        border = '2px 0px 0px 2px';
                    }
                }
                const styleLine = {
                    left: left,
                    top: top,
                    right: right,
                    bottom: bottom,
                    borderWidth: border,
                    borderColor: '#8fcae7',
                    borderStyle: 'solid'
                };
                line = <span className="seehi_poi_line" style={styleLine}></span>
            }
            return <span key={key} 
                    className={'seehi_poi' + (this.state.poiSelected===key? ' seehi_poi_selected': '')} 
                    style={style} 
                    tabIndex="0"
                    onKeyDown={(e) => ( e.keyCode !== 13 || this.setState({poiSelected: this.state.poiSelected===key? null: key}) )}
                    onClick={() => (this.setState({poiSelected: this.state.poiSelected===key? null: key}))}
                ></span>;
        });

        const styleInfoApplied = extend(this.state.orientation === 'landscape'? {}: {
            position: 'relative',
            right: '0px',
            width: 'calc(100% - 40px)'
        }, styleInfo);

        const styleImgApplied = extend(this.state.orientation === 'landscape'? {}: {
            width: '100%',
            paddingTop: '100%'
        }, styleImg);

        return <div className="seehi_step" ref={this.domNode}>
            <h2>Waar kunt u subsidie voor krijgen?</h2>
            <p>De subsidie is bedoeld voor energiebesparende maatregelen. U kunt subsidie aanvragen voor een bestaande woning. Woningen gebouwd voor het jaar 2000 hebben veel besparingspotentieel. De subsidie geldt niet voor bijgebouwen, nieuwe aanbouw of ingrijpende herzieningen, zoals het ombouwen van bedrijfsruimte naar een woning. Hieronder een overzicht.</p>
            <div style={styleImgApplied}>
                {line}
                {poiElements.map((element) => (element))}
            </div>
            <div style={styleInfoApplied}>
                {info}
            </div>
            <div style={styleButtons}>
                <p>Verder op deze pagina leest u hoe u aan de slag kunt gaan met het uitvoeren van de maatregelen. Alvast benieuwd of u 
                    in aanmerking komt voor de subsidie? Doe dan de subsidiecheck.</p>
                <a href="#seehiStep3" className="seehi_button seehi_actionButton">Aan de slag</a>
                <a href="#seehiStep6" className="seehi_button seehi_actionButton">Doe de subsidiecheck</a>
            </div> 
        </div>;
    }
}

export default Step2;


// WEBPACK FOOTER //
// ./src/steps/step2.js